import React, { useEffect, useState } from "react";
import Card from "components/common/Card";
import { Msg } from "./components/Msg";
import { OurAdvice } from "./components/OurAdvice";
import PolicyActions from "./components/PolicyActions";
import { Disclaimer } from "./components/Disclaimer";
import ButtonOutline from "components/semantic/ButtonOutline";
import Button from "components/semantic/Button";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import { getLifeResult, getSinglePolicy } from "store/thunk/kyp.thunk";
import { useNavigate, useParams } from "react-router-dom";
import ResultHeading from "./components/Heading";
import MailCopyModal from "./components/MailCopyModal";
import PaymentCard from "pages/benefitSummary/components/PaymentCard";
import { BlurScreenResult } from "./components/blurScreenResult";
import PolicySkeletonCard from "./components/SkeletonCard";
import { HeadingSmallScreen } from "./components/headingSmallScreen";
import { onGmailShare } from "utils/utils";
import { ImpactCard } from "./components/ImpactCard";

const LifeResult: React.FC = () => {
  const param: any = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [showCopyModal, setShowCopyModal] = useState(false);

  const lifeResultData = useAppSelector((state) => state.rootReducer.kypSlice.lifeResultData);
  const policyData = useAppSelector((state) => state.rootReducer.kypSlice.policyData);

  useEffect(() => {
    dispatch(getSinglePolicy(param?.policyId));
    dispatch(getLifeResult({ policyId: param?.policyId }));
  }, [dispatch, param]);

  const goToHomeHandler = () => {
    navigate("/kyp/policies");
  };

  return (
    <div className="max-w-5xl mx-auto">
      <h1 className="text-2xl font-extrabold mb-6">Know Your Policy</h1>
      {!policyData || !lifeResultData ? (
        <PolicySkeletonCard />
      ) : (
        <>
          {!["PAID", "WAIVEOFF"].includes(policyData.kypPaymentStatus) ? (
            <>
              <BlurScreenResult type={lifeResultData.ResultTitle} />
              <PaymentCard feeAmount={policyData.kypFeeAmount} />
            </>
          ) : (
            <Card className="rounded-xl md:shadow-sm shadow-none overflow-hidden" parentClassName=" !shadow-none md:shadow-xl border-none md:border-[1px]" bg="bg-none md:bg-white">
              <ResultHeading resultData={lifeResultData} />
              <Msg policyData={lifeResultData} />
              <div className="md:hidden sm:px-6">
                <HeadingSmallScreen onCopy={() => setShowCopyModal(true)} onGmailShare={() => onGmailShare(lifeResultData)} policyData={lifeResultData} policyType={policyData.policyTypeId} />
              </div>
              <div className="hidden  md:grid grid-cols-1 md:grid-cols-3 gap-6 my-10 sm:px-6 md:px-12">
                <ImpactCard title="Health & Lifestyle" status={lifeResultData?.qualityCheckContent[0].SubTitle} description={lifeResultData?.qualityCheckContent[0].Description} score={lifeResultData?.qualityCheckContent[0].Score} />
                <ImpactCard title="Financial & Occupation" status={lifeResultData?.qualityCheckContent[1].SubTitle} description={lifeResultData?.qualityCheckContent[1].Description} score={lifeResultData?.qualityCheckContent[1].Score} />
                <ImpactCard title="Contact & Admin" status={lifeResultData?.qualityCheckContent[2].SubTitle} description={lifeResultData?.qualityCheckContent[2].Description} score={lifeResultData?.qualityCheckContent[2].Score} />
              </div>
              <div className="sm:px-6 mx-0 md:mx-6">
                {lifeResultData.ResultTitle !== "Healthy" && <OurAdvice onCopy={() => setShowCopyModal(true)} onGmailShare={() => onGmailShare(lifeResultData)} policyData={lifeResultData} addText="by copying the mail content." />}
                {lifeResultData.ResultTitle && (
                  <div className="hidden xl:block bg-[#F4F5FA] rounded-xl border border-[#E4E6F2] py-5">
                    <PolicyActions type={lifeResultData.ResultTitle} onDownload={() => window.open(lifeResultData.detailedKypPdfUrl)} onCopy={() => setShowCopyModal(true)} onGmailShare={() => onGmailShare(lifeResultData)} id={policyData.policyTypeId} detailedKypPdfUrl={lifeResultData?.detailedKypPdfUrl} />
                  </div>
                )}
                {lifeResultData.ResultTitle !== "Healthy" && <Disclaimer bg={false} />}
              </div>
              <div className="flex gap-1 md:gap-4 justify-center items-center py-5 px-2 w-full md:px-5 border-t md:rounded-none rounded-xl bg-white">
                <ButtonOutline title="Go To Home" onClick={goToHomeHandler} className="w-full border-gray-300" />
                <Button title="Check Another Policy" onClick={() => navigate("/kyp/upload-policy")} className="w-full mx-1 text-sm md:text-base" />
              </div>
            </Card>
          )}
          <MailCopyModal isOpen={showCopyModal} onClose={() => setShowCopyModal(!showCopyModal)} mailDetails={lifeResultData?.Draft} />
        </>
      )}
    </div>
  );
};

export default LifeResult;
